import React, { useRef, useState, useEffect } from "react";
import "./UOD.css";
import DropDown from "../CreateBatch/DropdownCB";
import { API_BASE_URL } from "../../Config/Config";
import Swal from "sweetalert2";
import CustomModal from "./studentModal";
import axios from "axios";
import FolderUpload from "./FolderUpload"; // Assuming FolderUpload is the updated DirectoryUpload component
import WarningImage from "./../../Assets/Images/CommanImages/yellow_warning.jpg";
import SuccessMessage from "./SucessComponent";
const UOD = (dataClient) => {
  const [courses, setCourses] = useState([]);
  const [courseOpted, setCourseOpted] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [testNames, setTestNames] = useState([]);
  const [selectedTest, setSelectedTest] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const fileInput = useRef(null);
  const [showAnimation, setShowAnimation] = useState(false);
  const [assessment_id, Selected_assessment_id] = useState("");
  const [studentsToSkip, setStudentsToSkip] = useState([]);
  const [studentsToOverride, setStudentsToOverride] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [students, setStudents] = useState([]);
  const [file, setFile] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState([]);
  const [apiFileNames, setApiFileNames] = useState([]);
  const [uploadedFileNames, setUploadedFileNames] = useState([]);
  const [files, setFiles] = useState([]);
  const [preSignedUrls, setPreSignedUrls] = useState([]);
  const [urlList, setUrlList] = useState([]);
  const [excelUploaded, setExcelUploaded] = useState(false);
  const [matchedFiles, setMatchedFiles] = useState([]);
  // Add this line at the beginning of your UOD component
  const [successMessageVisible, setSuccessMessageVisible] = useState(false);
  const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;
  const clientBranchId =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
  const clientId = dataClient.dataClient?.client_schema_name[6][0].client_id;

  const [showModalSider, setShowModalSider] = useState(false);
  const [animationSider, setAnimationSider] = useState("");

  const openModalSider = () => {
    setAnimationSider("active");
    setShowModalSider(true);
  };

  const closeModalSider = () => {
    setAnimationSider(""); // reset animation
    setTimeout(() => setShowModalSider(false), 500); // delay setting showModal to false
  };

  useEffect(() => {
    if (!showModalSider && animationSider !== "active") {
      setAnimationSider("closing");
    }
  }, [showModalSider]);

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`
        );

        const data = await response.json();

        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);
  useEffect(() => {
    const fetchAssessmentNames = async () => {
      if (courseOpted && searchKey) {
        try {
          const response = await fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-assessment-names/?assessment_type_id=2&course_id=${courseOpted}&client_branch_id=${clientId}&search_key=${searchKey}`
          );
          const data = await response.json();
          if (data.status === 200) {
            setTestNames(data.data);

            setShowDropdown(true);
          }
        } catch (error) {
          console.error("Error fetching assessment names:", error);
        }
      } else {
        setShowDropdown(false);
      }
    };
    fetchAssessmentNames();
  }, [courseOpted, searchKey]);
  const handleSearchChange = (event) => {
    setSearchKey(event.target.value);
  };
  const handleTestSelect = (test) => {
    setSelectedTest(test);

    setShowDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleDivClick = () => {
    if (!courseOpted || !selectedTest) {
      Swal.fire({
        title: "Error",
        text: "Please select a course and test before uploading a file.",
        icon: "error",
      });
    } else {
      // Reset the file input value
      fileInput.current.value = null;
      fileInput.current.click();
      // Only start the animation if a file is selected
      if (fileInput.current.files.length > 0) {
        setShowAnimation(true);
      }
    }
  };

  // const handleDivClick = () => {
  //   if (!courseOpted || !selectedTest) {
  //     Swal.fire({
  //       title: "Error",
  //       text: "Please select a course and test before uploading a file.",
  //       icon: "error",
  //     });
  //   } else {
  //     fileInput.current.click();
  //     setShowAnimation(true);
  //   }
  // };
  // const handleFileChange = async (event) => {
  //   const selectedFile = event.target.files[0];
  //   const data = new FormData();
  //   data.append("excel_file", selectedFile, selectedFile.name);
  //   setFile(selectedFile);

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/process-omr-excel/?assessment_id=${selectedTest.assessment_id}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           accept: "application/json",
  //         },
  //         body: data,
  //       }
  //     );

  //     if (!response.ok) {

  //       if (response.status === 500) {
  //         Swal.fire({
  //           title: "Error",
  //           text: "The server encountered an error processing the file. Please ensure the file format is supported.",
  //           icon: "error",
  //         }).then(() => window.location.reload());
  //         return;
  //       }
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const responseData = await response.json();
  //     const apiFileNames = responseData.url_list.map((item) =>
  //       item.file_path.split("\\").pop()
  //     );
  //     const preSignedUrls = responseData.url_list.map((item) => ({
  //       fileName: item.file_path.split("\\").pop(),
  //       url: item.url,
  //     }));

  //     setApiFileNames(apiFileNames);
  //     setPreSignedUrls(preSignedUrls);
  //     setUrlList(responseData.url_list);
  //     setShowAnimation(false);

  //     if (responseData.errors && responseData.errors.length > 0) {
  //       setErrors(responseData.errors);
  //       Swal.fire({
  //         title: "Missing Information",
  //         html: "Do you want to resolve the missing information or continue?<br/>Please see the bottom of the page for the missing information in the Excel file.",
  //         icon: "warning",
  //         showCancelButton: true,
  //         confirmButtonText: "Continue",
  //         cancelButtonText: "Fix Errors",
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           setStudents(responseData.data);
  //           if (responseData.data && responseData.data.length > 0) {
  //             setIsModalOpen(true);
  //           }
  //         }
  //       });
  //     } else {
  //       setErrors([]);
  //       setStudents(responseData.data);
  //       if (responseData.data && responseData.data.length > 0) {
  //         setIsModalOpen(true);
  //       }
  //     }
  //   } catch (error) {
  //     setShowAnimation(false);
  //     console.error(error);
  //   }

  //   // Reset the value of the file input field
  //   event.target.value = null;
  // };
 
 
  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    const data = new FormData();
    data.append("excel_file", selectedFile, selectedFile.name);
    setFile(selectedFile);

    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/process-omr-excel/?assessment_id=${selectedTest.assessment_id}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
          },
          body: data,
        }
      );

      const responseData = await response.json();

      if (responseData.status === 404) {
        Swal.fire({
          title: "Error",
          text: responseData.message,
          icon: "error",
        });
        return;
      }

      if (!response.ok) {
        if (response.status === 500) {
          Swal.fire({
            title: "Error",
            text: "The server encountered an error processing the file. Please ensure the file format is supported.",
            icon: "error",
          }).then(() => window.location.reload());
          return;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const apiFileNames = responseData.url_list.map((item) =>
        item.file_path.split("\\").pop()
      );
      const preSignedUrls = responseData.url_list.map((item) => ({
        fileName: item.file_path.split("\\").pop(),
        url: item.url,
      }));

      setApiFileNames(apiFileNames);
      setPreSignedUrls(preSignedUrls);
      setUrlList(responseData.url_list);
      setShowAnimation(false);

      if (responseData.errors && responseData.errors.length > 0) {
        setErrors(responseData.errors);
        Swal.fire({
          title: "Missing Information",
          html: "Do you want to resolve the missing information or continue?<br/>Please see the bottom of the page for the missing information in the Excel file.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Fix Errors",
        }).then((result) => {
          if (result.isConfirmed) {
            setStudents(responseData.data);
            if (responseData.data && responseData.data.length > 0) {
              setIsModalOpen(true);
            }
          }
        });
      } else {
        setErrors([]);
        setStudents(responseData.data);
        if (responseData.data && responseData.data.length > 0) {
          setIsModalOpen(true);
        }
      }
    } catch (error) {
      setShowAnimation(false);
      Swal.fire({
        title: "Error",
        text: "An error occurred while trying to serve your request. Please check your network connection and the input file for error and try again.",
        icon: "error",
      });
      console.error(error);
    }

    // Reset the value of the file input field
    event.target.value = null;
  };

  const handleOMRUpload = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("excel_file", file, file.name);

      const response = await fetch(
        // `${API_BASE_URL}/coaching-collaborator-api/api/v1/upload-omr-excel?assessment_id=${
        //   selectedTest.assessment_id
        // }&skip_rows=${studentsToSkip.join(",")}`,
        // `${API_BASE_URL}/coaching-collaborator-api/api/v1/upload-omr-excel?assessment_id=${
        //   selectedTest.assessment_id
        // }&user_name=${user_name}&skip_rows=${studentsToSkip.join(",")}`
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/upload-omr-excel?assessment_id=${selectedTest.assessment_id}&username=${user_name}&skip_rows=${studentsToSkip.join(",")}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
          },
          body: formData,
        }
      );
      const data = await response.json();
      console.log("OMR Upload Response:", data);
      if (data.message.status === 207) {
        setErrors(data.message.data);
        setShowModal(true);
      } else {
        return data;
      }
      if (data.message.status === 200) {
        setErrors(data.message.data);
        setShowModal(true);
      } else {
        return data;
      }
      if (data.message.status === 500) {
        setErrors(data.message.data);
        setShowModal(true);
      } else {
        return data;
      }
    }
  };
  const handleSave = async () => {
    openModalSider();
    try {
      const omrUploadResponse = await handleOMRUpload();
      if (omrUploadResponse && omrUploadResponse.url_list) {
        const apiFileNames = omrUploadResponse.url_list.map((item) =>
          item.file_path.split("\\").pop()
        );
        const preSignedUrls = omrUploadResponse.url_list.map((item) => ({
          fileName: item.file_path.split("\\").pop(),
          url: item.url,
        }));
        setApiFileNames(apiFileNames);
        setPreSignedUrls(preSignedUrls);
      }
      // closeModalSider();
      if (omrUploadResponse.message.status === 200) {
        setSuccessMessageVisible(true);
        closeModalSider();
      }
      if (omrUploadResponse.message.status === 207) {
        setShowModal(true);
        closeModalSider();
      }
      if (omrUploadResponse.message.status === 500) {
        setShowModal(true);
        closeModalSider();
      }
    } catch (error) {
      console.error(error);
      console.error(error.message);
      closeModalSider();
    }
  };

  // const handleSave = async () => {
  //   try {
  //     const omrUploadResponse = await handleOMRUpload();
  //     if (omrUploadResponse && omrUploadResponse.url_list) {
  //       const apiFileNames = omrUploadResponse.url_list.map((item) =>
  //         item.file_path.split("\\").pop()
  //       );
  //       const preSignedUrls = omrUploadResponse.url_list.map((item) => ({
  //         fileName: item.file_path.split("\\").pop(),
  //         url: item.url,
  //       }));
  //       setApiFileNames(apiFileNames);
  //       setPreSignedUrls(preSignedUrls);
  //       Swal.fire({
  //         title: "Success",
  //         text: "Files uploaded successfully",
  //         icon: "success",
  //         timer: 2000,
  //         confirmButtonColor: "#318682",
  //       }).then(() => {
  //         setTimeout(function () {
  //           window.location.reload();
  //         }, 100);
  //       });
  //     } else {
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     Swal.fire({
  //       title: "Error",
  //       text: error.message,
  //       icon: "error",
  //     });
  //   }
  // };
  const handleCloseModal = () => {
    setShowModal(false);
    setShowAnimation(false);
    window.location.reload();
  };
  const handleSkipChange = (rollNo) => {
    setStudentsToSkip((prev) => {
      if (prev.includes(rollNo)) {
        return prev.filter((roll) => roll !== rollNo);
      } else {
        return [...prev, rollNo];
      }
    });
  };
  const handleOverrideChange = (rollNo) => {
    setStudentsToOverride((prev) => {
      if (prev.includes(rollNo)) {
        return prev.filter((roll) => roll !== rollNo);
      } else {
        return [...prev, rollNo];
      }
    });
  };
  const handleSkipAll = () => {
    const allRollNumbers = students.map((student) => student.roll_no);
    setStudentsToSkip(allRollNumbers);
    setIsModalOpen(false);
  };
  const uploadExcelFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("excel_file", file);
      const response = await axios.post(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/process-omr-excel/?assessment_id=${selectedTest.assessment_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const urlList = response.data.url_list;
      setUrlList(urlList);
      setExcelUploaded(true);
      return urlList;
    } catch (error) {
      console.error("Error uploading Excel file: ", error);
    }
  };
  const uploadFileToS3 = async (file, presignedUrl) => {
    try {
      const result = await axios.put(presignedUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
      });
      console.log(result);
    } catch (error) {
      console.error("Error uploading file: ", error);
    }
  };
  const handleExcelFileChange = async (event) => {
    const excelFile = event.target.files[0];
    if (excelFile) {
      await uploadExcelFile(excelFile);
    }
  };
  const handleFolderChange = async () => {
    try {
      const dirHandle = await window.showDirectoryPicker();
      const files = [];
      for await (const entry of dirHandle.values()) {
        if (entry.kind === "file" && entry.name.match(/\.(jpg|jpeg|png)$/i)) {
          const file = await entry.getFile();
          files.push(file);
        }
      }
      setFiles(files);
      const matchedFiles = files.filter((file) =>
        urlList.some((urlObj) => urlObj.file_path === file.name)
      );
      setMatchedFiles(matchedFiles);
      setExcelUploaded(true); // Set excelUploaded to true here
    } catch (error) {
      console.error("Error selecting folder: ", error);
    }
  };

  const handleUploadClick = async () => {
    try {
      uploadImages(files);
    } catch (error) {
      console.error(error);
    }
  };
  const uploadImages = (files) => {
    for (const file of files) {
      const matchingUrl = urlList.find((urlObj) =>
        urlObj.file_path.includes(file.name)
      );
      if (matchingUrl) {
        uploadFileToS3(file, matchingUrl.url);
      }
    }
  };
  useEffect(() => {
    if (isModalOpen) {
    } else {
      setShowAnimation(false);
    }
  }, [isModalOpen]);

  const downloadErrors = () => {
    const element = document.createElement("a");
    const file = new Blob([errors.join("\n")], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "errors.txt";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div className="container-UP" style={{ position: "sticky", top: "0" }}>
        <div className="Header-up ">
          <p className="title-cb ">Upload OMR </p>

          <div className="mb-2-UP grey-color-font">
            <button className="cr-cancel-btn me-cs4" onClick={handleCancel}>
              CANCEL
            </button>

            <button
              className="cr-create-btn"
              onClick={() => {
                handleUploadClick();
                handleSave();
              }}
            >
              SAVE
            </button>
          </div>
        </div>

        <hr className="hr-otc" />
      </div>
      {successMessageVisible && (
        <SuccessMessage
          message="Files uploading . . ."
          countdownTime={10}
          onCountdownComplete={() => window.location.reload()}
        />
      )}

      <div className="container-cs-fluid ms-cs3 mt-cs3">
        <div className="card-cs1 card-border-CR">
          <div className="basic-info-color  transparent-margin-left-UP transparent-margin-all ">
            UPLOAD OMR DATA
          </div>

          <div style={{ padding: "15px" }}>
            <div style={{ position: "relative" }}>
              <DropDown
                label="Course"
                style={{ width: "25%" }}
                setSelected={setCourseOpted}
                options={courses.map((course) => ({
                  label: course.course_name,

                  id: course.course_id,
                }))}
                isRequired={true}
              />

              <br />

              <p className="color424342">Search Test</p>

              <div ref={dropdownRef}>
                <input
                  style={{
                    height: "32px",

                    width: "25%",

                    marginBottom: "10px",

                    marginTop: "8px",

                    padding: "5px",

                    color: "#424342",
                  }}
                  type="text"
                  placeholder=" Search test"
                  value={searchKey}
                  onChange={handleSearchChange}
                />

                {showDropdown && (
                  <div className="dropdown-UOD-1">
                    <div className="dropdown-UOD-2">
                      {testNames.map((test, index) => (
                        <div key={index} onClick={() => handleTestSelect(test)}>
                          <p style={{ padding: "10px" }}>
                            {test.assessment_name}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div>
            {selectedTest && (
              <div className="row-v grey-color-font header-color-dark border-top-bottom-UR">
                <div className="col-1-custom-v">
                  <div className="mb-3-v color424342">Batch:</div>

                  <div className="mb-3-v color424342">Date:</div>

                  <div className="mb-3-v color424342">Subject:</div>
                </div>

                <div className="col-v">
                  <div className="mb-3-v color424342">
                    {selectedTest.batch_name
                      ? selectedTest.batch_name
                      : "\u00A0"}
                  </div>

                  <div className="mb-3-v color424342">
                    {selectedTest.assignment_date
                      ? selectedTest.assignment_date
                      : "\u00A0"}
                  </div>

                  <div className="mb-3-v color424342">
                    {selectedTest.subject_name
                      ? selectedTest.subject_name
                      : "\u00A0"}
                  </div>
                </div>

                <div className="col-1-custom-v">
                  <div className="mb-3-v color424342">Test ID:</div>

                  <div className="mb-3-v color424342">Test Name:</div>

                  <div className="mb-3-v color424342">Course:</div>
                </div>

                <div className="col-v">
                  <div className="mb-3-v color424342">
                    {selectedTest.assessment_id
                      ? selectedTest.assessment_id
                      : "\u00A0"}
                  </div>

                  <div className="mb-3-v color424342">
                    {selectedTest.assessment_name
                      ? selectedTest.assessment_name
                      : "\u00A0"}
                  </div>

                  <div className="mb-3-v color424342">
                    {selectedTest.course_name
                      ? selectedTest.course_name
                      : "\u00A0"}
                  </div>
                </div>
              </div>
            )}

            <div
              className="UploadDivWhite"
              style={{
                marginLeft: "1%",
                marginTop: "10px",
                marginBottom: "10px",
                border: "1px dotted grey",
                height: "200px",
                width: "98%",
                backgroundColor: showAnimation ? "white" : "white",
                opacity: showAnimation ? 1 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              {!showAnimation && (
                <div className="Both-buttons-UOD">
                  <div
                    onClick={handleDivClick}
                    onChange={handleExcelFileChange}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <p style={{ marginRight: "10%" }}>
                      Browse the excel file generated by OMR software
                    </p>
                    <button className="Excel-UOD-button">Browse</button>
                  </div>

                  <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p style={{ marginRight: "4.1%" }}>
                        Browse the folder that contains OMR images for the excel
                        file
                      </p>
                      <button
                        className="Excel-UOD-button-2"
                        onClick={handleFolderChange}
                      >
                        Browse
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <input
                type="file"
                ref={fileInput}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              {showAnimation && (
                <div className="loader">
                  <div className="inner one"></div>

                  <div className="inner two"></div>

                  <div className="inner three"></div>
                </div>
              )}
            </div>
            <div>
              <div className="SiderNotification">
                {showModalSider && (
                  <div className={`modalSider ${animationSider}`}>
                    <h2>LOADING</h2>
                    <p>Please wait processing data ... </p>
                  </div>
                )}
              </div>
            </div>
            <div>
              {isModalOpen && (
                <CustomModal
                  students={students}
                  handleSkip={handleSkipChange}
                  handleSkipAll={handleSkipAll}
                  handleOverride={handleOverrideChange}
                  closeModal={() => setIsModalOpen(false)}
                />
              )}
            </div>
            {/* <div>
              {showModal && (
                <div className="modal-overlay-UOD">
                  <div className="modal-container-UOD">
                    <div>
                      {" "}
                      <span
                        className="none-x-button-UOD"
                        onClick={handleCloseModal}
                        style={{}}
                      >
                        {" "}
                        <button
                          style={{
                            border: "none",
                            background: "transparent",
                            fontSize: "18px",
                          }}
                        >
                          ×
                        </button>
                    
                      </span>
                    </div>

                    <div className="modal-header-UOD">
                      <h2>Success with Warnings</h2>
                    </div>

                    <div className="modal-body-UOD">
                      <p className="text-p-UOD">
                        Please see details below for the rows that were not
                        uploaded:
                      </p>
                      <table className="errors-table-UOD">
                        <tbody>
                          {errors.map((error, index) => (
                            <tr key={index}>
                              <td className="errors-errors-UOD">{error}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="modal-footer-UOD">
                      <button onClick={handleCloseModal}>Close</button>    <button className="download-error" onClick={downloadErrors}>
                          Download Errors
                        </button>
                    </div>
                  </div>
                </div>
              )}
            </div> */}
            <div>
              {showModal && (
                <div className="modal-overlay-UOD">
                  <div className="modal-container-UOD">
                    <div>
                      {" "}
                      <span
                        className="none-x-button-UOD"
                        onClick={handleCloseModal}
                        style={{}}
                      >
                        {" "}
                        <button
                          style={{
                            border: "none",

                            background: "transparent",

                            fontSize: "18px",
                          }}
                        >
                          ×
                        </button>
                      </span>
                    </div>

                    <div className="modal-header-UOD">
                      <h2>OMR Uploaded Successfully</h2>
                    </div>

                    <div className="modal-body-UOD">
                      <p className="text-p-UOD">
                        Please see details below for the rows that were not
                        uploaded:
                      </p>

                      <table className="errors-table-UOD">
                        <tbody>
                          {errors.map((error, index) => (
                            <tr key={index}>
                              <td className="errors-errors-UOD">{error}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="modal-footer-UOD">
                      <button onClick={downloadErrors}>Download Errors</button>{" "}
                      <button onClick={handleCloseModal}>Close</button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div style={{ width: "100%" }}>
              {excelUploaded && (
                <>
                  <div className="file-row-div-UOD">
                    <p className="basic-color-info-UOD">
                      OMR images are being processed please click on Save to
                      continue :
                    </p>
                    <div className="file-row">
                      {matchedFiles.map((file, index) => (
                        <div key={index} style={{ whiteSpace: "normal" }}>
                          {file.name}
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div style={{ padding: "15px" }}>
              {/* <p className="color424342"> Count of Students: </p> */}

              {errors.length > 0 && (
                <div>
                  <p className="color424342" style={{ paddingTop: "5px" }}>
                    Warning:
                  </p>

                  <ul style={{ paddingTop: "5px" }}>
                    {errors.map((error, index) => (
                      <li
                        style={{ paddingTop: "5px", color: "darkred" }}
                        key={index}
                      >
                        {error}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UOD;
